import { heroImg } from "@/mocks/homeData";

const chips = ["红毯生图", "路透街拍", "发布会现场", "机场抓拍", "音乐节现场", "综艺录制"];

const stats = [
  { num: "68K+", label: "收录现场图" },
  { num: "320+", label: "热门事件" },
  { num: "24h", label: "实时直击" },
];

const go = (id: string) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden bg-foreground-950">
      <img
        src={heroImg}
        alt="热点现场高清图集背景，舞台灯光与人群剪影"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/30"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/40"></div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-background-50 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-background-50"></span>
            </span>
            全网热点 · 现场生图持续更新中
          </span>

          <h1 className="mt-6 text-3xl md:text-6xl font-heading font-bold text-background-50 leading-tight tracking-tight">
            吃瓜图集
            <span className="block text-accent-300 mt-1">高清现场 · 一网打尽</span>
          </h1>

          <p className="mt-5 text-sm md:text-lg leading-relaxed text-background-100/90 max-w-2xl">
            首页聚合活动现场实拍图、路透照、高清生图与抓拍瞬间。点开就能看各路现场直出，路透照与活动生图按事件持续更新，找图不用来回翻。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch gap-3">
            <button
              onClick={() => go("live")}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-focus-3-line text-lg"></i>
              进入现场直击
            </button>
            <button
              onClick={() => go("gallery")}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50/30 transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-image-2-line text-lg"></i>
              浏览高清生图
            </button>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {chips.map((c) => (
              <button
                key={c}
                onClick={() => go("themes")}
                className="px-3 py-1.5 rounded-full text-xs font-medium text-background-100 bg-background-50/10 border border-background-50/20 hover:bg-accent-500 hover:text-background-50 hover:border-accent-500 transition whitespace-nowrap cursor-pointer"
              >
                #{c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-3 sm:gap-4 max-w-2xl">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-50/15 px-4 py-4 text-center">
              <p className="text-xl md:text-2xl font-heading font-bold text-accent-300">{s.num}</p>
              <p className="mt-1 text-[11px] md:text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-10 hidden md:flex items-center gap-2 text-background-100/60 text-xs">
        <i className="ri-camera-3-line"></i>
        实拍原图 · 无过度后期
      </div>
    </section>
  );
}